import lang from '../../lib/language';
import { useMarketTimer } from '../../lib/util/hooks/MarketTimerHook';

import iconClose from '../../assets/img/close-line.svg';
import { useIsMobile } from '../../hooks';
import BaseModal from '../../shared_components/BaseModal/BaseModal';
import Button from '../../shared_components/Button/Button';
import ClickableImage from '../ClickableImage/ClickableImage';

import styles from './RegularTradingHoursStartModal.module.scss';

type Props = {
  toggleModal: () => void;
};

const RegularTradingHoursStartModal = ({ toggleModal }: Props) => {
  const { timerValueAsString, isEnabled } = useMarketTimer('short-sell');
  const { isMobile } = useIsMobile();
  if (!isEnabled) return null;

  return (
    <BaseModal
      isOpen
      customStyle={
        isMobile
          ? {
            paddingBottom: 46,
            margin: 0,
            width: window.innerWidth,
            marginTop: window.innerHeight / 2.5,
            position: 'fixed',
            alignSelf: 'flex-end',
          }
          : undefined
      }
    >
      <div className={styles.titleAndClose}>
        <h6 className={styles.title}>{lang.commonRegularTradingHoursStartDialogTitle()}</h6>
        {isMobile && <ClickableImage src={iconClose} onClick={toggleModal} />}
      </div>

      <div className={styles.description}>
        <p>
          {lang.commonRegularTradingHoursStartDialogDescription()}
          <span className={styles.marketTimer}>{timerValueAsString}</span>
        </p>
      </div>
      <Button fullWidth className={styles.button} onClick={toggleModal}>
        {lang.commonOkay()}
      </Button>
    </BaseModal>
  );
};

export default RegularTradingHoursStartModal;
